module.exports = __webpack_public_path__ + "static/media/svgradiobutton_inactive.05039fdf.svg";